<h2 mat-dialog-title class="d-flex align-items-center gap-2">
    <mat-icon color="primary">business</mat-icon>
    Dettaglio Struttura
</h2>

<mat-dialog-content>
    <div *ngIf="loading" class="d-flex justify-content-center p-5">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="error" class="alert alert-danger">
        Impossibile recuperare i dettagli della struttura.
    </div>

    <div *ngIf="!loading && struttura">
        <div class="info-row-sm">
            <span class="label-sm">Denominazione</span>
            <span class="value-sm"><b>{{struttura.denominazione}}</b></span>
        </div>
        <div class="info-row-sm">
            <span class="label-sm">Codice Struttura</span>
            <span class="value-sm"><code>{{struttura.codice}}</code></span>
        </div>
        
        <div class="info-row-sm" *ngIf="struttura.parentDetails">
            <span class="label-sm">Unità Superiore</span>
            <span class="value-sm">{{struttura.parentDetails.descrizione}} ({{struttura.parentDetails.codice}})</span>
        </div>

        <div class="info-row-sm">
            <span class="label-sm">Cod. Nazionale ASL</span>
            <span class="value-sm">{{struttura.codNazionaleAsl || 'Non disponibile'}}</span>
        </div>

        <div class="mt-3" *ngIf="struttura.strutture?.length">
            <span class="label-sm d-block mb-2">Sottostrutture / Nuclei:</span>
            <ul class="list-group list-group-flush">
                <li class="list-group-item py-1 px-0 border-0" *ngFor="let sub of struttura.strutture">
                    <mat-icon class="valign-middle" style="font-size: 16px; width: 16px; height: 16px;">subdirectory_arrow_right</mat-icon>
                    <small class="ms-2">{{sub.denominazione}} ({{sub.codice}})</small>
                </li>
            </ul>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>